import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getArticles } from './articles';
import Article from './components/Article';

import './index.scss';

const b = b_.with('main-page-news');

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const News: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()} data-testid={'main-page-news'}>
      {getArticles(t).map((article, index) => (
        <Article key={article.title} index={index} />
      ))}
    </div>
  );
};

export default translate(News);
